/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum TimeCommitment {
  Between1And10 = "1-10",
  Between11And20 = "11-20",
  Between21And30 = "21-30",
  Between31And40 = "31-40",
  MoreThan40 = "40+",
}

export const TimeCommitmentDisplay: Record<TimeCommitment, string> = {
  [TimeCommitment.Between1And10]: "1-10",
  [TimeCommitment.Between11And20]: "11-20",
  [TimeCommitment.Between21And30]: "21-30",
  [TimeCommitment.Between31And40]: "31-40",
  [TimeCommitment.MoreThan40]: "40+",
};
